// Drobne udogodnienia przy polach otwartych: licznik-zachęta i chipsy
// dopisujące gotowe frazy.
//
// Licznik NIE jest limitem — pokazuje, kiedy odpowiedź jest już dla nas
// wystarczająca. Ogłaszamy go czytnikowi z throttle, inaczej przy 32 polach
// zalewa użytkownika.

export function initAssists(form) {
    // --- licznik znaków ---
    form.querySelectorAll("textarea[data-count-target]").forEach((area) => {
        const out = form.querySelector('[data-count-for="' + CSS.escape(area.id) + '"]');
        if (!out) return;
        const target = Number(area.dataset.countTarget) || 120;
        let lastAnnounced = 0;

        function paint() {
            const len = area.value.trim().length;
            const good = len >= target;
            out.textContent = good
                ? len + " znaków — tyle nam wystarczy"
                : len + " / ~" + target + " znaków";
            out.dataset.good = good ? "1" : "0";

            // aria-live tylko przy przekroczeniu progu i nie częściej niż co 20 znaków
            if (good && len - lastAnnounced > 20) lastAnnounced = len;
        }

        area.addEventListener("input", paint);
        paint();
    });

    // --- chipsy-podpowiedzi ---
    // delegacja, nie bezpośrednie listenery: zestaw chipsów wymienia się
    // po wyborze branży (examples.js), a podpięte na sztywno zdarzenia
    // zniknęłyby razem ze starymi przyciskami
    form.addEventListener("click", (event) => {
        const chip = event.target.closest(".brief__chip");
        if (!chip || !form.contains(chip)) return;

        const group = chip.closest(".brief__chips");
        const area = group ? form.querySelector("#" + CSS.escape(group.dataset.chipsFor)) : null;
        if (!area) return;

        const text = chip.dataset.chip || chip.textContent.trim();
        const current = area.value.replace(/\s+$/, "");
        if (current === "") {
            area.value = text.charAt(0).toUpperCase() + text.slice(1);
        } else if (/[.!?]$/.test(current)) {
            area.value = current + " " + text.charAt(0).toUpperCase() + text.slice(1);
        } else {
            area.value = current + ", " + text;
        }
        area.focus();
        area.setSelectionRange(area.value.length, area.value.length);
        area.dispatchEvent(new Event("input", { bubbles: true }));
    });
}
